/**
 * TL-057: document title, favicon and PWA manifest link per tenant.
 * The manifest is served by the backend at `/manifest.webmanifest` (the host
 * decides the tenant); the vite-plugin-pwa service worker is unchanged.
 */

import { withBase } from "./basePath";
import type { Tenant } from "@/lib/api/tenant";

function setMeta(name: string, content: string): void {
  document.head.querySelector(`meta[name="${name}"]`)?.setAttribute("content", content);
}

export function applyDocumentIdentity(tenant: Tenant): void {
  document.title = `${tenant.displayName} Workspace`;
  setMeta("description", `${tenant.displayName} Workspace. Lessons, homework, progress and messages.`);
  setMeta("apple-mobile-web-app-title", tenant.displayName);

  const icon = tenant.logoMarkUrl ?? tenant.logoUrl;
  if (icon) {
    for (const el of document.head.querySelectorAll<HTMLLinkElement>('link[rel="icon"]')) el.remove();
    const link = document.createElement("link");
    link.rel = "icon";
    link.href = icon;
    document.head.appendChild(link);
  }

  let manifest = document.head.querySelector<HTMLLinkElement>('link[rel="manifest"]');
  if (!manifest) {
    manifest = document.createElement("link");
    manifest.rel = "manifest";
    document.head.appendChild(manifest);
  }
  manifest.href = withBase("/manifest.webmanifest");
}
